import { createFileRoute } from '@tanstack/react-router';
import { DripGoalSubTab } from '@/components/admin/DripGoalSubTab';

function Page() {
  return <DripGoalSubTab goal='growth' />;
}

export const Route = createFileRoute('/admin/drip-campaigns/growth')({
  component: Page,
});
